import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { MERCHANT_API_PATH } from "src/confs/APIConfig";
import { Merchant } from "src/merchants/objects/Merchant";
import { useApiGet } from "src/shared/actions/FetchActions";

export const useMerchantsSearch = (
  term: string,
  options?: UseQueryOptions<
    Merchant[],
    unknown,
    Merchant[],
    ["merchants", "term", string]
  >,
) => {
  const apiGet = useApiGet();
  return useQuery(
    ["merchants", "term", term],
    async () => {
      const { data } = await apiGet<Merchant[]>(
        `${MERCHANT_API_PATH}/action/_search`,
        {
          term,
        },
      );
      return data.map((merchantJson) => {
        return new Merchant(merchantJson);
      });
    },
    options,
  );
};
